/* eslint-disable security/detect-object-injection */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-debugger */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IProductRefinerHierarchy } from '@msdyn365-commerce/commerce-entities';
import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { ILobasRoofTableData } from './lobas-roof-table.data';
import {
    /*expandRefinersCount,*/
    ILobasRoofTableConfig,
    ILobasRoofTableProps,
    ISubHeaderElementData
} from './lobas-roof-table.props.autogenerated';
import {
    IModuleProps,
    INodeProps,
    getTelemetryObject,
    //ILabeledDropdownOption,
    ITelemetryContent,
    //IPayLoad,
    //getPayloadObject,
    Heading //,
    /*LabeledDropdown,*/
    //UncontrolledPagination
} from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { /*IItemReference,*/ IRoof } from '../../actions/DataServiceEntities.g';
import { computed, observable, transaction, reaction } from 'mobx';
import MsDyn365, { IRequestContext } from '@msdyn365-commerce/core';
import { observer } from 'mobx-react';
import LobasTable, {
    ILobasDataTableProps,
    ILobasHeadingsProperty,
    ILobasLinkProps,
    ILobasTableItemProps,
    ILobasTableRefinerHierarchy,
    ILobasTableRefinerValue,
    /*ILobasTableRefinerValue,*/
    ILobasTableRowProps,
    LobasTableDataType
} from '../components/lobas-table';
import { buildListPageUrl, getCurrentUrl, hydrateRefinersFromUrl } from '../../actions/lobas-url-utils';
//import LobasRefineSubmenu from '../components/lobas-refine-submenu';
//import { ILobasTableRefineItemToggleNotification } from '../components/lobas-refine-item-toggle-notification';
import { getUpdatedRefinementCriteria /*, isMatchingRefinementCriterion*/ } from '../components/lobas-utilities';
import { ILobasTableRefineItemCommonProps } from '../components/lobas-refine-item.props.common';
//import ChoiceSummary from '../components/lobas-choice-summary';
//import { IChoiceSummaryClickNotification } from '../components/lobas-choice-summary.props';
//import { AttributeDataType } from '@msdyn365-commerce/retail-proxy';
//import getRoofTableAction from '../../actions/get-roof-table.action';
//import { getRoofTableAsync } from '../../actions/DataActionExtension.g';
import { ListPageState } from '../../actions/lobas-list-page-state';
import { IRefineMenuViewProps } from '../lobas-search-result-container/lobas-search-result-container';
//import RefineSubmenu from '../lobas-search-result-container/components/refine-submenu';
//import { IRefineItemToggleNotification, getUpdatedRefinementCriteria } from '../lobas-search-result-container/components';
import LobasRefineSubmenu from '../components/lobas-refine-submenu';
import { ILobasTableRefineItemToggleNotification } from '../components/lobas-refine-item-toggle-notification';
import { getRelatedProductsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
//import { ProductSearchResult } from '@msdyn365-commerce/retail-proxy';

export interface ILobasRoofTableViewProps extends ILobasRoofTableProps<{}> {
    RoofList: IModuleProps;
    moduleContainer: INodeProps;
    heading: React.ReactNode;
    roofListTable: React.ReactNode;
    refineMenu: ILobasRoofTableRefineMenuViewProps;
    RefineAndModuleSectionContainer: INodeProps;
    //choiceSummary: React.ReactNode;
    pagination?: React.ReactNode;
    productSegmentRefiners: React.ReactNode;
    productCategoryRefiners: React.ReactNode;
}

export interface ILobasProductSegmentProps {
    ProductSegmentName: string;
    IsActive: boolean;
}

export interface ILobasProductCategoryProps {
    ProductCategoryName: string;
    IsActive: boolean;
}

export interface ILobasRoofTableState {
    //sortingState: ISortByCollectionState;
    refiners: ILobasTableRefinerHierarchy[];
    isReady: boolean;
    refresh: boolean;
    productSegments: ILobasProductSegmentProps[];
    productCategories: ILobasProductCategoryProps[];
    tableProps: ILobasDataTableProps | undefined;
}

export interface ISortByViewProps {
    SortingContainer: INodeProps;
    sortByDropDown?: React.ReactNode;
}

export type GridSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface ILobasRoofTableRefineMenuViewProps {
    RefineMenuContainer: INodeProps;
    RefinerSectionContainer: INodeProps;
    refiners?: React.ReactNode[];
}

export const sortOptions = {
    sortByOptionRelevanceDesc: 'Ranking-Desc',
    sortByOptionRatingAsc: 'AverageRating-Asc',
    sortByOptionRatingDesc: 'AverageRating-Desc',
    sortByOptionNameAsc: 'Name-Asc',
    sortByOptionNameDesc: 'Name-Desc',
    sortByOptionPriceAsc: 'Price-Asc',
    sortByOptionPriceDesc: 'Price-Desc',
    sortByOptionBestSelling: 'BestSelling',
    sortByOptionNewScore: 'NewScore',
    sortByOptionTrendingScore: 'TrendingScore'
};

/*interface ISortByCollectionState {
    selectedSortByOption: ILabeledDropdownOption;
    pending: boolean;
}*/
/**
 *
 * Lobas roof table component
 * @extends {React.PureComponent<ILobasRoofTableProps<ILobasRoofTableData>>}
 */
@observer
class LobasRoofTable extends React.PureComponent<ILobasRoofTableProps<ILobasRoofTableData>, ILobasRoofTableState> {
    @computed get isMobile(): boolean {
        return this._viewport === 'xs' || this._viewport === 'sm';
    }

    @observable
    private _viewport: GridSize;

    private readonly telemetryContent: ITelemetryContent;

    //private readonly defaultPageNumber = 0;

    private readonly mobileExcludedColumns: string[];

    private readonly moduleClassName: string = 'ms-business-organization-list';

    //private expandrefinerCount: number | undefined = 0;

    private readonly _refineItemCommonProps: ILobasTableRefineItemCommonProps;

    //private readonly _sortAndFilterContainerRef: React.RefObject<LabeledDropdown>;

    private readonly _pageType: string | undefined = this.props.context.request.urlTokens.pageType;

    private isListPageStateUpdated: boolean = false;

    private refiners: IProductRefinerHierarchy[] | [];

    public constructor(props: ILobasRoofTableProps<ILobasRoofTableData>, state: ILobasRoofTableState) {
        super(props);
        this.mobileExcludedColumns = [];
        this._viewport =
            props.context.request && props.context.request.device && props.context.request.device.Type === 'Mobile' ? 'xs' : 'lg';
        this._updateViewport = this._updateViewport.bind(this);

        this.state = {
            isReady: false,
            refresh: true,
            refiners: [],
            productSegments: [
                { ProductSegmentName: 'Taksikkerhet', IsActive: false },
                { ProductSegmentName: 'Fallsikring', IsActive: false },
                { ProductSegmentName: 'Solar', IsActive: false }
            ],
            productCategories: this.props.config.headers
                ? this.props.config.headers?.map(data => ({ ProductCategoryName: data.name, IsActive: false }))
                : [],
            tableProps: undefined
        };

        //this._sortAndFilterContainerRef = React.createRef<LabeledDropdown>();

        const { placeholderTextMax, minLabel, maxLabel, rangeNameFormat } = this.props.resources;
        const locale = this.props.context.request.locale;
        const telemetry = this.props.telemetry;
        const validationErrorNaN = this.props.resources.validationErrorNotNumber;
        const validationErrorRange = this.props.resources.validationErrorNotRange;

        this._refineItemCommonProps = {
            telemetry,
            locale,
            placeholderTextMax,
            minLabel,
            maxLabel,
            rangeNameFormat,
            validationErrorNaN,
            validationErrorRange
        };
        this.telemetryContent = getTelemetryObject(
            this.props.context.request.telemetryPageName!,
            this.props.friendlyName,
            this.props.telemetry
        );

        this._updateViewport();

        this.refiners = [];
    }

    public async componentDidMount(): Promise<void> {
        if (MsDyn365.isBrowser && window.addEventListener) {
            window.addEventListener('resize', this._updateViewport);
            this._updateViewport();
        }

        const [listPageState, roofTable] = await Promise.all([this.props.data.listPageState, this.props.data.roofTable]);

        this._updateListPageState(listPageState, roofTable);

        const tableProps = await this._createTableProps(roofTable); // This method now contains the async logic
        this.setState({ tableProps: tableProps });

        for (const segment of this.state.productSegments) {
            const categories =
                this.props.config.headers &&
                this.props.config.headers.filter(header => header.productSegment === segment.ProductSegmentName);

            if (categories && categories.length === 1) {
                this.setState((prevState: ILobasRoofTableState) => {
                    const updatedItems = prevState.productCategories.map(category => {
                        if (category.ProductCategoryName === categories[0].name) {
                            return { ...category, IsActive: true };
                        }
                        return category;
                    });

                    return { productCategories: updatedItems, refresh: true };
                });
            }
        }

        /*reaction(
            () => {
                return [listPageState.currentPageNumber];
            },
            async () => {
                const newListPageState = await this.props.data.listPageState;
                const newRoofTable = await getRoofTableAsync({
                    callerContext: this.props.context.actionContext,
                    queryResultSettings: {
                        Paging: {
                            Top: this.props.config.itemsPerPage,
                            Skip: Math.max(newListPageState.pageSize * (newListPageState.currentPageNumber ?? 0), 0)
                        }
                    }
                });

                /*this.refiners = await getProductRefinerHierarchy(
                    {
                        Context: {
                            ChannelId: this.props.app.apiSettings.channelId,
                            CatalogId: this.props.app.catalogId
                        }
                    },
                    {
                        Paging: {
                            Top: this.props.config.itemsPerPage,
                            Skip: Math.max(newListPageState.pageSize * (newListPageState.currentPageNumber ?? 0), 0)
                        }
                    },
                    this.props.context.actionContext
                );

                newListPageState.totalTableCount = newRoofTable.length;
                newListPageState.activeRoofs = newRoofTable;
            }
        );*/
        this.props.data.roofTable.then(roofTable => {
            this.props.data.listPageState.then(listPageState => {
                if (this._pageType === 'Category') {
                    listPageState.pageType = 'Category';
                } else {
                    listPageState.pageType = 'Search';
                }

                //let querySorting: SortColumn[] = [];

                /*if (this.props.context.request.query && this.props.context.request.query.sorting) {
                    querySorting = JSON.parse(decodeURIComponent(this.props.context.request.query.sorting)) as SortColumn[];
                }

                listPageState.currentPageNumber =
                    (this.props.context.request.query &&
                        +this.props.context.request.query.skip / this.props.config.itemsPerPage(1000 || 10)) ||
                    0;
                //listPageState.sortingCritera = { Columns: querySorting };
                listPageState.pageSize = /*this.props.config.itemsPerPage 1000 || 10;*/
                listPageState.activeRoofs = roofTable;
                listPageState.totalTableCount = roofTable.length;
                listPageState.activeFilters = hydrateRefinersFromUrl(this.props.context.request);

                // Initialize reaction based on listPageState properties
                reaction(
                    () => {
                        return [
                            listPageState.activeFilters && listPageState.activeFilters.length,
                            listPageState.currentPageNumber //,
                            /*listPageState.sortingCritera &&
                                listPageState.sortingCritera.Columns &&
                                listPageState.sortingCritera.Columns.length*/
                        ];
                    },
                    async () => {
                        const roofTable = this._getActiveRoofs(listPageState.activeFilters);
                        listPageState.activeRoofs = roofTable;
                        listPageState.totalTableCount = roofTable.length;
                        this.setState({ tableProps: await this._createTableProps(roofTable) });
                        /*if (this.props.config.updateRefinerPanel) {
                            const refiners = this._getRefiners(listPageState.activeRoofs);s
                            this.setState({ refiners });
                        }*/
                    }
                );
            });
        });
        //this.payLoad = getPayloadObject('click', this.telemetryContent, '');
    }

    public componentWillUnmount(): void {
        if (MsDyn365.isBrowser && window.removeEventListener) {
            window.removeEventListener('resize', this._updateViewport);
        }
    }

    public render(): JSX.Element | null {
        const {
            data: { listPageState, roofTable }
        } = this.props;

        if (!this.isListPageStateUpdated && listPageState.result && roofTable.result) {
            //this._updateListPageState(listPageState.result, roofTable.result);
            this.isListPageStateUpdated = true;
        }

        const { heading, className } = this.props.config;
        /*const {
            formItems,
            isFormActive,
            formType,
            isModalOpen,
            statementRequestFromDateString,
            statementRequestToDateString,
            isStatementRequestModalOpen
        } = this.state;*/

        const viewProps = {
            ...this.props,
            className: classnames('ms-search-result-container', className),
            RoofList: {
                moduleProps: this.props,
                className: classnames(this.moduleClassName, className)
            },
            moduleContainer: {
                className: `${this.moduleClassName}__container`
            },
            heading: heading && <Heading className={`${this.moduleClassName}__heading`} headingTag={heading.tag} text={heading.text} />,
            roofListTable: this.state.tableProps ? <LobasTable {...this.state.tableProps} /> : <></>,
            refineMenu: this._getRefineMenu(),
            RefineAndModuleSectionContainer: { className: 'ms-search-result-container__refine-product-section' },
            productSegmentRefiners: this._getProductSegmentRefiners(),
            productCategoryRefiners: this._getProductCategoryRefiners()
            //choiceSummary: this._getChoiceSummary()
            //pagination: this._getPagination()
        } as ILobasRoofTableViewProps;

        return this.props.renderView(viewProps) as React.ReactElement;
    }

    private async _createTableProps(content: IRoof[] | []): Promise<ILobasDataTableProps> {
        const { config, resources, context } = this.props;
        //const { tableSort, showPagination, paginationItemPerPage } = config;
        //const { businessUserPaginationNextButtonText, businessUserPaginationPreviousButtonText, businessUserEditButtonText, businessUserViewUserButtonText,
        //businessUserDeleteButtonText, businessUserActionButtonText, businessUserPaginationAriaLabel, columnSortAriaLabel } = resources;

        const tableData = await this._createTableItems(content);
        const tableHeading = this._createTableHeaders(config);
        const tableSubHeading = this._createTableSubHeaders(config);

        return {
            resources,
            headings: tableHeading,
            subheadings: tableSubHeading,
            rows: tableData,
            className: `${this.moduleClassName}__table`,
            enableToModify: false,
            showCheckBoxes: false,
            isSortable: true,
            resourcePrefix: 'businessUser',
            minifyActions: this.isMobile,
            excludedColumns: this.isMobile ? this.mobileExcludedColumns : [],
            paginationProperty: {
                skipCount:
                    context &&
                    context.request &&
                    context.request.query &&
                    context.request.query.skip &&
                    !isNaN(Number.parseInt(context.request.query.skip, 10))
                        ? Number.parseInt(context.request.query.skip, 10)
                        : 0,
                itemPerPage: 1000,
                prevText: resources.businessUserPaginationPreviousButtonText,
                nextText: resources.businessUserPaginationNextButtonText,
                paginationText: resources.businessUserPaginationAriaLabel,
                url: (context && this._getCurrentUrl(context.request).href) || ''
            },
            isSingleSelectOnly: true,
            sortByAscending: resources.sortByAscending,
            sortByDescending: resources.sortByDescending,
            actions: {},
            sourceProps: this.props,
            isRefinerMenuExpandedOnInitialLoad: false
        };
    }

    private _createTableHeaders(content: ILobasRoofTableConfig): (ILobasHeadingsProperty | undefined)[] {
        const tableHeading =
            (ArrayExtensions.hasElements(content.headers) &&
                content.headers.map(item => {
                    if (
                        (!item.itemCategory && !item.subHeaderElements) ||
                        (this.state.productSegments.some(
                            segment => segment.ProductSegmentName === item.productSegment && segment.IsActive
                        ) &&
                            this.state.productCategories.some(category => category.ProductCategoryName === item.name && category.IsActive))
                    ) {
                        if (this.isMobile && this.mobileExcludedColumns.includes(item.name)) {
                            return undefined;
                        }
                        return {
                            name: item.name,
                            sortable: item.roofDataReference ? true : false,
                            ariaLabel: this.props.resources.columnSortAriaLabel,
                            colspan: item.subHeaderElements ? item.subHeaderElements.length : 1
                        } as ILobasHeadingsProperty;
                    }
                    return undefined;
                })) ||
            [];

        return tableHeading;
    }

    private _createTableSubHeaders(content: ILobasRoofTableConfig): (ILobasHeadingsProperty | undefined)[] {
        const tableSubHeading: (ILobasHeadingsProperty | undefined)[] = [];

        ArrayExtensions.hasElements(content.headers) &&
            content.headers.map(header => {
                if (
                    (!header.itemCategory && !header.subHeaderElements) ||
                    (this.state.productSegments.some(segment => segment.ProductSegmentName === header.productSegment && segment.IsActive) &&
                        this.state.productCategories.some(category => category.ProductCategoryName === header.name && category.IsActive))
                ) {
                    const subHeaders = (header.subHeaderElements as unknown) as ISubHeaderElementData[];
                    if (subHeaders && subHeaders.length > 0) {
                        subHeaders.map(subHeader => {
                            if (this.isMobile && this.mobileExcludedColumns.includes(subHeader.name)) {
                                tableSubHeading.push(undefined);
                            }
                            tableSubHeading.push({
                                name: subHeader.name,
                                sortable: false,
                                ariaLabel: '',
                                colspan: 1
                            });
                        });
                    } else {
                        tableSubHeading.push({
                            name: '',
                            sortable: false,
                            ariaLabel: '',
                            colspan: 1
                        });
                    }
                }
            });

        return tableSubHeading;
    }

    private async _createTableItems(content: IRoof[] | undefined): Promise<ILobasTableRowProps[]> {
        const roofTable = content;

        if (!ArrayExtensions.hasElements(roofTable)) {
            return [];
        }

        const tableRows: ILobasTableRowProps[] = [];

        for (const roof of roofTable) {
            const row = await this._createTableDataRow(roof);
            tableRows.push({
                row: row,
                isSelected: false
            });
        }

        return tableRows;
    }

    private async _createTableDataRow(roof: IRoof): Promise<ILobasTableItemProps[]> {
        const config = this.props.config;
        const categories = config.headers;
        const dataRow: ILobasTableItemProps[] = [];

        const distinctItems = [...new Map(roof.ItemReferences?.map(item => [item['Id'], item])).values()];

        if (!ArrayExtensions.hasElements(categories)) {
            return [];
        }

        for (const category of categories) {
            if (
                (!category.itemCategory && !category.subHeaderElements) ||
                (this.state.productSegments.some(segment => segment.ProductSegmentName === category.productSegment && segment.IsActive) &&
                    this.state.productCategories.some(
                        productCategory => productCategory.ProductCategoryName === category.name && productCategory.IsActive
                    ))
            ) {
                if (category.roofDataReference && !ArrayExtensions.hasElements(category.subHeaderElements)) {
                    const values = Object.values(roof);
                    const propertyIndex = Object.keys(roof).findIndex(x => x === category.roofDataReference);
                    let valueType = null;

                    // eslint-disable-next-line security/detect-object-injection
                    switch (typeof values[propertyIndex]) {
                        case 'number':
                            valueType = LobasTableDataType.Number;
                            break;
                        case 'string':
                            valueType = LobasTableDataType.Text;
                            break;
                        default:
                            valueType = LobasTableDataType.Text;
                    }

                    dataRow.push({
                        id: `${category.name}`,
                        // eslint-disable-next-line security/detect-object-injection
                        type: valueType === LobasTableDataType.Number && values[propertyIndex] === 0 ? LobasTableDataType.Text : valueType,
                        // eslint-disable-next-line security/detect-object-injection
                        value: valueType === LobasTableDataType.Number && values[propertyIndex] === 0 ? '' : values[propertyIndex],
                        isLinkItem: false
                    });
                } else if ((category.itemCategory && category.itemReference) || ArrayExtensions.hasElements(category.subHeaderElements)) {
                    if (ArrayExtensions.hasElements(category.subHeaderElements)) {
                        const subHeaderElements = (category.subHeaderElements as unknown) as ISubHeaderElementData[];

                        for (const subHeaderElement of subHeaderElements) {
                            if (
                                !(category.productSegment === 'Solar' && subHeaderElement.itemCategory.toLowerCase().includes('innfeste'))
                            ) {
                                const fitleredItems =
                                    distinctItems &&
                                    distinctItems.filter(
                                        x =>
                                            x.Model === roof?.Id &&
                                            x.Category === subHeaderElement.itemCategory &&
                                            x.Name?.includes(subHeaderElement.itemReference) &&
                                            this._checkAdditionalItemReferences(x.Name, subHeaderElement.additionalItemReferences)
                                    );

                                if (ArrayExtensions.hasElements(fitleredItems)) {
                                    dataRow.push({
                                        id: `${subHeaderElement.name}`,
                                        type: LobasTableDataType.Text,
                                        value: '',
                                        isLinkItem: true,
                                        links: fitleredItems.map(item => {
                                            let newName = item.Name;
                                            this.props.config.hiddenTexts &&
                                                this.props.config.hiddenTexts.forEach(text => {
                                                    newName = newName ? newName.replace(text, '') : '';
                                                });
                                            return {
                                                linkUrl: `${this.props.context.request.url.requestUrl.origin}/${item.Product}.p`,
                                                linkText: newName,
                                                linkType: '',
                                                disabled: item.ProductReference === 0 ? true : false
                                            } as ILobasLinkProps;
                                        })
                                    });
                                } else {
                                    dataRow.push({
                                        id: `${subHeaderElement.name}`,
                                        type: LobasTableDataType.Text,
                                        value: '',
                                        isLinkItem: false
                                    });
                                }

                                if (subHeaderElement.itemCategory === 'Solarkonsoller') {
                                    //const relatedProducts: ProductSearchResult[] | null | undefined = [];

                                    const promises = fitleredItems.map(item =>
                                        getRelatedProductsAsync(
                                            { callerContext: this.props.context.actionContext },
                                            item.Product!,
                                            this.props.context.request.apiSettings.channelId,
                                            this.props.context.request.apiSettings.catalogId,
                                            5637144576
                                        )
                                    );

                                    const allRelatedProductsResult = await Promise.all(promises);

                                    if (ArrayExtensions.hasElements(allRelatedProductsResult)) {
                                        dataRow.push({
                                            id: 'Innf.sk',
                                            type: LobasTableDataType.Text,
                                            value: '',
                                            isLinkItem: true,
                                            links: allRelatedProductsResult.flatMap(relatedProducts => {
                                                return relatedProducts
                                                    .filter(relatedProduct => relatedProduct.Name?.toLowerCase().includes('innfeste'))
                                                    .map(item => {
                                                        let newName = item.Name;
                                                        this.props.config.hiddenTexts &&
                                                            this.props.config.hiddenTexts.forEach(text => {
                                                                newName = newName ? newName.replace(text, '') : '';
                                                            });
                                                        return {
                                                            linkUrl: `${this.props.context.request.url.requestUrl.origin}/${item.RecordId}.p`,
                                                            linkText: newName,
                                                            linkType: '',
                                                            disabled: false
                                                        } as ILobasLinkProps;
                                                    });
                                            })
                                        });
                                    } else {
                                        dataRow.push({
                                            id: `${category.name}`,
                                            type: LobasTableDataType.Text,
                                            value: '',
                                            isLinkItem: false
                                        });
                                    }
                                }
                            }
                        }
                    } else {
                        const fitleredItems =
                            distinctItems &&
                            distinctItems.filter(
                                x =>
                                    x.Model === roof?.Id &&
                                    x.Category === category.itemCategory &&
                                    x.Name?.includes(category.itemReference !== undefined ? category.itemReference : '') &&
                                    this._checkAdditionalItemReferences(x.Name, category.additionalItemReference)
                            );
                        if (ArrayExtensions.hasElements(fitleredItems)) {
                            dataRow.push({
                                id: `${category.name}`,
                                type: LobasTableDataType.Text,
                                value: '',
                                isLinkItem: true,
                                links: fitleredItems.map(item => {
                                    let newName = item.Name;
                                    this.props.config.hiddenTexts &&
                                        this.props.config.hiddenTexts.forEach(text => {
                                            newName = newName ? newName.replace(text, '') : '';
                                        });
                                    return {
                                        linkUrl: `${this.props.context.request.url.requestUrl.origin}/${item.Product}.p`,
                                        linkText: newName,
                                        linkType: '',
                                        disabled: item.ProductReference === 0 ? true : false
                                    } as ILobasLinkProps;
                                })
                            });
                        } else {
                            dataRow.push({
                                id: `${category.name}`,
                                type: LobasTableDataType.Text,
                                value: '',
                                isLinkItem: false
                            });
                        }
                    }
                } else {
                    dataRow.push({
                        id: `${category.name}`,
                        type: LobasTableDataType.Text,
                        value: '',
                        isLinkItem: false
                    });
                }
            }
        }

        return dataRow;
    }

    private _checkAdditionalItemReferences(input: string, itemReferences: string[] | undefined): boolean {
        let withoutExclamation: string[] = [];
        let withExclamation: string[] = [];
        let containsForbidden = false;
        let containsAllAllowed = true;

        if (itemReferences && ArrayExtensions.hasElements(itemReferences)) {
            // Split the array into two arrays: one with and one without exclamation marks
            withoutExclamation = itemReferences.filter(str => str !== null && !str.startsWith('!'));
            withExclamation = itemReferences.filter(str => str !== null && str.startsWith('!')).map(str => str.substring(1)); // removing the exclamation mark

            containsForbidden = withExclamation.some(forbiddenStr => input.includes(forbiddenStr));
            containsAllAllowed = withoutExclamation.every(allowedStr => input.includes(allowedStr));
        }

        return containsAllAllowed && !containsForbidden;
    }

    public handleHeadingChange = (event: Msdyn365.ContentEditableEvent): void => {
        this.props.config.heading!.text = event.target.value;
    };

    private _getViewport(): GridSize {
        const { context } = this.props;

        // Always render in mobile viewport on a mobile device
        if (context.request && context.request.device && context.request.device.Type === 'Mobile') {
            return 'xs';
        }

        if (MsDyn365.isBrowser && window.innerWidth) {
            const gridSettings = context.request.gridSettings;
            if (gridSettings) {
                if (gridSettings.xs && window.innerWidth <= gridSettings.xs.w) {
                    return 'xs';
                } else if (gridSettings.sm && window.innerWidth <= gridSettings.sm.w) {
                    return 'sm';
                } else if (gridSettings.md && window.innerWidth <= gridSettings.md.w) {
                    return 'md';
                } else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
                    return 'lg';
                }
                return 'xl';
            }
        }

        return 'lg';
    }

    private _updateViewport(): void {
        this._viewport = this._getViewport();
    }

    private readonly _getCurrentUrl = (reqContext: IRequestContext): URL => {
        if (MsDyn365.isBrowser) {
            return new URL(window.location.href);
        }

        // NOTE: Typing on requestURL is incorrect
        if (reqContext.url.requestUrl.href) {
            return new URL(reqContext.url.requestUrl.href);
        }
        return new URL(reqContext.url.requestUrl.href);
    };

    private readonly _getRefineMenu = (): IRefineMenuViewProps => {
        const { data, context /*, config*/ } = this.props;
        const tempRangeTypeTODO = context.request.query && context.request.query.inputRange ? 'input' : 'slider';
        const validRefiners =
            this.props.config.updateRefinerPanel && ArrayExtensions.hasElements(this.refiners)
                ? this.refiners.filter(refiner => {
                      return ArrayExtensions.hasElements(refiner.Values) && !this._shouldHideFromRefiners(refiner);
                  })
                : this.refiners &&
                  this.refiners.filter(refiner => {
                      return ArrayExtensions.hasElements(refiner.Values) && !this._shouldHideFromRefiners(refiner);
                  });

        const activeRefiners = (data.listPageState.result && data.listPageState.result.activeFilters) || [];

        //this._getexpandRefinerCount(validRefiners && validRefiners.length, config.expandRefinersCount);
        //const expandedRefiners = this.expandrefinerCount;
        const subMenus =
            validRefiners &&
            validRefiners.map((productRefinerHierarchy: IProductRefinerHierarchy, index: number) => {
                return (
                    <LobasRefineSubmenu
                        tableRefinerHierarchy={productRefinerHierarchy}
                        selectedRefinerValues={activeRefiners}
                        refineItemCommonProps={this._refineItemCommonProps}
                        minValueSliderThumbAriaLabel={this.props.resources.minValueSliderThumbAriaLabel}
                        maxValueSliderThumbAriaLabel={this.props.resources.maxValueSliderThumbAriaLabel}
                        key={index}
                        onUpdateRefiners={this._onUpdateRefiners}
                        urlBuilder={this._buildRefinerUrl}
                        isDisabled={false}
                        isExpandedOnInitialLoad={true /*!!(expandedRefiners && expandedRefiners > index)*/}
                        tempRangeTypeTODO={tempRangeTypeTODO}
                        context={context}
                        moduleId={this.props.id}
                        moduleTypeName={this.props.typeName}
                        telemetryContent={this.telemetryContent}
                        productCountAriaLabel={this.props.resources.productCountAriaLabel}
                        //refineItemAriaLabel={this.props.resources.refineItemAriaLabel}
                        //refineItemsAriaLabel={this.props.resources.refineItemsAriaLabel}
                        singleProductCountAriaLabel={this.props.resources.singleProductCountAriaLabel}
                        isMobile={this.isMobile}
                    />
                );
            });

        return {
            RefineMenuContainer: { className: 'ms-search-result-container__refine-menu lobas-dropdown' },
            RefinerSectionContainer: { className: 'ms-search-result-container__refiner-section lobas-dropdown' },
            refiners: subMenus
        };
    };

    /**
     * Should hide from refiners.
     * @param refiner - The refiner.
     * @returns ShouldHideFromRefiners.
     */
    private readonly _shouldHideFromRefiners = (refiner: IProductRefinerHierarchy): boolean => {
        // Always hide sortable attribute since it's just for sorting products in Azure search, not for customers
        return (
            //refiner.RecordId === this.props.data.products.result?.inventoryAwareSortableAttributeId ||
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- app configs are of generic type
            /*(this.props.context.app.config.productListInventoryDisplay === ProductListInventoryFilteringOptions.HideOOS &&
                refiner.RecordId === this.props.data.products.result?.channelInventoryConfigurationId) ||*/
            (refiner.KeyName !== 'Pris' &&
                refiner.KeyName !== 'Price' &&
                ArrayExtensions.hasElements(this.props.config.hiddenRefiners) &&
                this.props.config.hiddenRefiners.filter(refinerName => refinerName === refiner.KeyName).length > 0) ||
            ((refiner.KeyName === 'Pris' || refiner.KeyName === 'Price') &&
                !(
                    this.props.context.request.user.isAuthenticated &&
                    ((this.props.context.request.user.customerAccountNumber !== null &&
                        this.props.context.request.user.customerAccountNumber !== '') ||
                        this.props.context.request.user.isOBORequest)
                ))
        );
    };

    /*private readonly _getRefiners = (activeRoofs: IRoof[] | undefined): ILobasTableRefinerHierarchy[] => {
        const { config } = this.props;
        const refinersWithValue: ILobasTableRefinerHierarchy[] = [];

        //Creating list of headers we want to use as filters. Only use headers which has a
        //roofDataReference value and does not have any elements in subHeaderElements array
        const refiners =
            config.headers &&
            config.headers
                .filter(header => header.roofDataReference && !ArrayExtensions.hasElements(header.subHeaderElements))
                .map((header, index) => {
                    return {
                        name: header.name,
                        reference: header.roofDataReference,
                        key: index
                    };
                });

        //Creating refinersWithValues
        if (refiners) {
            refiners.map(refiner => {
                if (refiner.name) {
                    const refinerValues = activeRoofs
                        ? activeRoofs.map(roof => {
                              return {
                                  RefinerRecordId: roof.Id,
                                  RefinerSourceValue: Object.keys(roof).findIndex(x => x === refiner.reference),
                                  LeftValueBoundString: Object.values(roof)[Object.keys(roof).findIndex(x => x === refiner.reference)],
                                  DataTypeValue: 5
                              };
                          })
                        : [];

                    let uniqueRefinerValues: ILobasTableRefinerValue[] = [];

                    if (typeof refinerValues[0].LeftValueBoundString === 'number') {
                        uniqueRefinerValues = [
                            {
                                LeftValueBoundString: `${Math.min.apply(
                                    Math,
                                    refinerValues.map(x => {
                                        return x.LeftValueBoundString;
                                    })
                                )}`,
                                RightValueBoundString: `${Math.max.apply(
                                    Math,
                                    refinerValues.map(x => {
                                        return x.LeftValueBoundString;
                                    })
                                )}`,
                                RefinerSourceValue: refinerValues[0].RefinerSourceValue,
                                DataTypeValue: 4
                            }
                        ];
                    } else {
                        uniqueRefinerValues = [...new Map(refinerValues.map(value => [value['LeftValueBoundString'], value])).values()];
                    }

                    refinersWithValue.push({
                        KeyName: refiner.name,
                        DataTypeValue: uniqueRefinerValues[0].DataTypeValue,
                        DisplayTemplateValue: uniqueRefinerValues[0].DataTypeValue === AttributeDataType.Text ? 0 : 1,
                        Values: uniqueRefinerValues
                    });
                }
            });
        }

        for (var i = 0; i < refinersWithValue.length; i++) {
            if (
                (refinersWithValue[i].DataTypeValue !== AttributeDataType.Text &&
                    refinersWithValue[i].Values[0].LeftValueBoundString === '0' &&
                    refinersWithValue[i].Values[0].RightValueBoundString === '0') ||
                refinersWithValue[i].Values.length === 0
            ) {
                refinersWithValue.splice(i, 1);
                i--;
            }
        }

        return refinersWithValue;
    };*/

    /*private readonly _getexpandRefinerCount = (validRefiners?: number, refinerCount?: expandRefinersCount): void => {
        switch (refinerCount) {
            case expandRefinersCount.all:
                this.expandrefinerCount = validRefiners;
                break;
            case expandRefinersCount.one:
                this.expandrefinerCount = 1;
                break;
            case expandRefinersCount.two:
                this.expandrefinerCount = 2;
                break;
            case expandRefinersCount.three:
                this.expandrefinerCount = 3;
                break;
            case expandRefinersCount.four:
                this.expandrefinerCount = 4;
                break;
            default:
                this.expandrefinerCount = 0;
        }
    };*/

    private readonly _onUpdateRefiners = (itemToggleNotification: ILobasTableRefineItemToggleNotification): void => {
        const { context } = this.props;
        const requestContext = context && context.request;
        const actionContext = context && context.actionContext;

        if (!requestContext || !actionContext || !this.props.data.listPageState.result) {
            const error = `Refine menu cannot refine search criteria: ${!requestContext ? 'requestContext ' : ''} ${
                !actionContext ? 'actionContext ' : ''
            } could not be found`;
            this.props.telemetry.warning(error);
        }

        const updatedRefinementCriteria = getUpdatedRefinementCriteria(
            itemToggleNotification,
            (this.props.data.listPageState.result && this.props.data.listPageState.result.activeFilters) || []
        );

        window.history.pushState({}, '', buildListPageUrl(getCurrentUrl(this.props.context.request), updatedRefinementCriteria));
        transaction(() => {
            this.props.data.listPageState.result!.currentPageNumber = 0;
            this.props.data.listPageState.result!.activeFilters = updatedRefinementCriteria;
        });
    };

    private readonly _buildRefinerUrl = (itemToggleNotification: ILobasTableRefineItemToggleNotification): string => {
        if (this.props.data.listPageState.result) {
            const newRefinementCriteria = getUpdatedRefinementCriteria(
                itemToggleNotification,
                this.props.data.listPageState.result.activeFilters || []
            );

            return buildListPageUrl(getCurrentUrl(this.props.context.request), newRefinementCriteria);
        }
        this.props.telemetry.warning('[buildRefinerQueryString]List Page State Not available, unable to build refiner URL');
        return '';
    };

    /*private readonly _getChoiceSummary = (): React.ReactNode => {
        const { resources, data, telemetry } = this.props;
        const selectedRefiners = (data.listPageState.result && data.listPageState.result.activeFilters) || [];

        return (
            <ChoiceSummary
                classNames='ms-choice-summary-by-category'
                clearAllText={resources.clearAllText}
                label={resources.choiceSummaryLabel}
                closeAriaLabel={resources.closeAriaLabel}
                selectedChoices={selectedRefiners}
                refinerHierarchy={this._getRefiners(data.roofTable.result)}
                choiceFormat={resources.choiceFormat}
                choiceRangeValueFormat={resources.choiceRangeValueFormat}
                telemetry={telemetry}
                onChoiceClicked={this._onChoiceClicked}
                urlBuilder={this._buildRefinerUrlForChoiceSummary}
                choiceAriaLabel={resources.choiceAriaLabel}
                telemetryContent={this.telemetryContent}
                context={this.props.context}
            />
        );
    };*/

    /*private readonly _onChoiceClicked = (notification: IChoiceSummaryClickNotification): void => {
        const { data, telemetry } = this.props;

        if (!data.listPageState.result) {
            telemetry.warning('[choice-summary-by-category._onChoiceClicked]ListPageState unavailable, unable to update refiners.');
            return;
        }

        let currentRefinementCriteria = (data.listPageState.result && data.listPageState.result.activeFilters) || [];

        if (!notification.clearAll) {
            const selectedChoice = notification.choiceClicked;
            if (!selectedChoice) {
                telemetry.warning('[choice-summary-by-category._onChoiceClicked] Choice could not be determined');
                return;
            }
            currentRefinementCriteria = currentRefinementCriteria.filter(
                (selectedCriterion: ILobasTableRefinerValue) => !isMatchingRefinementCriterion(selectedChoice, selectedCriterion)
            );
        } else {
            currentRefinementCriteria = [];

            // Set focus to sort and filter
            const dropdownElementId = this._sortAndFilterContainerRef.current && this._sortAndFilterContainerRef.current.props.dropdownId;
            const dropdownElement = dropdownElementId && document.getElementById(dropdownElementId);
            setTimeout(() => {
                dropdownElement && dropdownElement.focus();
            }, 50);
        }

        const fullUrl = getCurrentUrl(this.props.context.request);
        window.history.pushState({}, '', buildListPageUrl(fullUrl, currentRefinementCriteria));
        data.listPageState.result.currentPageNumber = 0;
        data.listPageState.result.activeFilters = currentRefinementCriteria;
    };*/

    /*private readonly _buildRefinerUrlForChoiceSummary = (selectedRefiner: ILobasTableRefinerValue, isClearAll: boolean): string => {
        const { data, telemetry } = this.props;
        const fullUrl = getCurrentUrl(this.props.context.request);

        if (!data.listPageState.result) {
            telemetry.warning('[choice-summary-by-category._buildRefinerUrl]ListPageState unavailable, unable to create refiner URL.');
            return fullUrl.href;
        }

        let currentRefinementCriteria = (data.listPageState.result && data.listPageState.result.activeFilters) || [];

        if (!isClearAll) {
            if (!selectedRefiner) {
                telemetry.warning('[choice-summary-by-category._buildRefinerUrl] URL for Choice could not be determined');
                return fullUrl.href;
            }
            currentRefinementCriteria = currentRefinementCriteria.filter(
                (selectedCriterion: ILobasTableRefinerValue) => !isMatchingRefinementCriterion(selectedRefiner, selectedCriterion)
            );
        } else {
            currentRefinementCriteria = [];
        }

        return buildListPageUrl(fullUrl, currentRefinementCriteria);
    };*/

    private readonly _getActiveRoofs = (activeFilters: ILobasTableRefinerValue[] | null): IRoof[] => {
        const roofTable = this.props.data.roofTable.result;

        let activeRoofs: IRoof[] = [];

        if (roofTable) {
            if (activeFilters) {
                activeRoofs = roofTable.filter(roof => {
                    return activeFilters
                        .map(filter => {
                            if (
                                roof.TypeName === filter.LeftValueBoundString ||
                                roof.CoveringName === filter.LeftValueBoundString ||
                                roof.ManufacturerName === filter.LeftValueBoundString ||
                                roof.ModelName === filter.LeftValueBoundString
                            ) {
                                return true;
                            } else {
                                return false;
                            }
                        })
                        .every(x => x === true);
                });
            } else {
                activeRoofs = roofTable;
            }
        }

        return activeRoofs;
    };

    private readonly _updateListPageState = (listPageState: ListPageState, roofTable: IRoof[]): void => {
        //let querySorting: SortColumn[] = [];
        //const defaultPageNumber: number = 10;

        if (this._pageType === 'Category') {
            listPageState.pageType = 'Category';
        } else {
            listPageState.pageType = 'Search';
        }

        /*if (this.props.context.request.query?.sorting) {
            querySorting = JSON.parse(decodeURIComponent(this.props.context.request.query.sorting)) as SortColumn[];
        }*/

        /*listPageState.currentPageNumber =
            (this.props.context.request.query &&
                +this.props.context.request.query.skip / (this.props.config.itemsPerPage ?? defaultPageNumber)) ||
            0;*/
        //listPageState.sortingCritera = { Columns: querySorting };
        //listPageState.pageSize = this.props.config.itemsPerPage ?? defaultPageNumber;
        listPageState.activeRoofs = roofTable;
        listPageState.totalTableCount = roofTable.length;
        listPageState.activeFilters = hydrateRefinersFromUrl(this.props.context.request);
        /*if (this.props.context.request.query?.productId) {
            const featureProduct = this.props.data.featureProduct.result;
            if (featureProduct) {
                listPageState.featureProduct = featureProduct;
            }
        }*/
    };

    /*private readonly _getPagination = (): React.ReactNode => {
        const { config, context, data, resources } = this.props;
        const listPageState = data.listPageState.result;
        const fullUrl = getCurrentUrl(context.request);
        const itemsPerPage = config.itemsPerPage || 10;
        // eslint-disable-next-line max-len -- existing code
        const skipCount = listPageState?.currentPageNumber
            ? listPageState.currentPageNumber * (this.props.config.itemsPerPage || 10)
            : (this.props.context.request.query && +this.props.context.request.query.skip) || 0;
        const totalItems = listPageState?.totalTableCount || 0;
        const previousText = resources.flipperPrevious;
        const nextText = resources.flipperNext;

        if (totalItems <= itemsPerPage) {
            return null;
        }
        return (
            <UncontrolledPagination
                className='ms-search-result-container__pagination'
                role='navigation'
                aria-label={resources.paginationAriaLabel}
                url={fullUrl.href}
                qsp='skip'
                items={totalItems}
                itemsPerPage={itemsPerPage}
                startingItem={skipCount}
                previousText={this._renderPrev(previousText)}
                nextText={this._renderNext(nextText)}
                previousAriaLabel={previousText}
                nextAriaLabel={nextText}
                telemetryContent={this.telemetryContent}
            />
        );
    };*/

    /**
     * Renders a Pagination previous text.
     * @param  paginationPreviousText - Pagination previous text from resources.
     * @returns Previous text and flipper icon.
     */
    /*private readonly _renderPrev = (paginationPreviousText: string) => {
        return (
            <div className='msc-pagination__prev'>
                <span className='ms-search-result__pagination-left' aria-hidden='true' />
                <span className='prev-text'>{paginationPreviousText}</span>
            </div>
        );
    };*/

    /**
     * Renders a Pagination next text.
     * @param  paginationNextText - Pagination next text from resources.
     * @returns Next text and flipper icon.
     */
    /*private readonly _renderNext = (paginationNextText: string) => {
        return (
            <div className='msc-pagination__next'>
                <span className='next-text'>{paginationNextText}</span>
                <span className='ms-search-result__pagination-right' aria-hidden='true' />
            </div>
        );
    };*/

    private readonly _getProductSegmentRefiners = (): React.ReactNode => {
        return (
            <div className='lobas-product-segment-refiners'>
                <div className='lobas-product-segment-refiner-header'>{this.props.resources.productSegmentRefiners}</div>
                <div className='lobas-product-segment-refiner-container'>
                    <a
                        role='checkbox'
                        aria-label='Taksikkerhet'
                        className={`${'lobas-product-segment-refiner ms-refine-submenu-item multi-select'}${
                            this.state.productSegments[0].IsActive ? '-checked' : ''
                        }`}
                        onClick={this._onClick}
                        tabIndex={0}
                        aria-selected={this.state.productSegments[0].IsActive}
                    >
                        <span className=''>Taksikkerhet</span>
                    </a>
                    <a
                        role='checkbox'
                        aria-label='Fallsikring'
                        className={`${'lobas-product-segment-refiner ms-refine-submenu-item multi-select'}${
                            this.state.productSegments[1].IsActive ? '-checked' : ''
                        }`}
                        onClick={this._onClick}
                        tabIndex={0}
                        aria-selected={this.state.productSegments[1].IsActive}
                    >
                        <span className='lobas-product-segment-refiner-label'>Fallsikring</span>
                    </a>
                    <a
                        role='checkbox'
                        aria-label='Solar'
                        className={`${'lobas-product-segment-refiner ms-refine-submenu-item multi-select'}${
                            this.state.productSegments[2].IsActive ? '-checked' : ''
                        }`}
                        onClick={this._onClick}
                        tabIndex={0}
                        aria-selected={this.state.productSegments[2].IsActive}
                    >
                        <span className='lobas-product-segment-refiner-label'>Solar</span>
                    </a>
                </div>
            </div>
        );
    };

    private readonly _getProductCategoryRefiners = (): React.ReactNode => {
        const refiners = [];
        if (this.props.config.headers && ArrayExtensions.hasElements(this.props.config.headers)) {
            for (const category of this.props.config.headers) {
                const productSegment = this.state.productSegments.find(x => x.ProductSegmentName === category.productSegment);
                if (productSegment && productSegment.IsActive) {
                    const productCategory = this.state.productCategories.find(x => x.ProductCategoryName === category.name);
                    refiners.push(
                        <a
                            role='checkbox'
                            aria-label={category.name}
                            className={`${'lobas-category-refiner ms-refine-submenu-item multi-select'}${
                                productCategory && productCategory.IsActive ? '-checked' : ''
                            }`}
                            onClick={this._onClickCategories}
                            tabIndex={0}
                            aria-selected={productCategory && productCategory.IsActive}
                        >
                            <span className='lobas-category-refiner-label'>{category.name}</span>
                        </a>
                    );
                }
            }
        }

        if (this.state.productSegments.some(segment => segment.IsActive)) {
            return (
                <div className='lobas-category-refiners'>
                    <div className='lobas-category-refiner-header'>{this.props.resources.productCategoryRefiners}</div>
                    <div className='lobas-category-refiner-container'>{refiners}</div>
                </div>
            );
        } else {
            return <></>;
        }
    };

    private readonly _onClick = async (e: React.MouseEvent<HTMLAnchorElement | HTMLInputElement>): Promise<void> => {
        e.preventDefault();
        // eslint-disable-next-line no-debugger
        const control = e.currentTarget.textContent;

        this.setState((prevState: ILobasRoofTableState) => {
            const updatedItems = prevState.productSegments.map(segment => {
                if (segment.ProductSegmentName === control) {
                    return { ...segment, IsActive: !segment.IsActive };
                }
                return segment;
            });

            return { productSegments: updatedItems, refresh: true };
        });

        const listPageState = await this.props.data.listPageState;
        const activeRoofs = listPageState.activeRoofs;
        const tableProps = await this._createTableProps(activeRoofs);
        this.setState({ tableProps });
    };

    private readonly _onClickCategories = async (e: React.MouseEvent<HTMLAnchorElement | HTMLInputElement>): Promise<void> => {
        e.preventDefault();
        // eslint-disable-next-line no-debugger
        const control = e.currentTarget.textContent;

        this.setState((prevState: ILobasRoofTableState) => {
            const updatedItems = prevState.productCategories.map(category => {
                if (category.ProductCategoryName === control) {
                    return { ...category, IsActive: !category.IsActive };
                }
                return category;
            });

            return { productCategories: updatedItems, refresh: true };
        });

        const listPageState = await this.props.data.listPageState;
        const activeRoofs = listPageState.activeRoofs;
        const tableProps = await this._createTableProps(activeRoofs);
        this.setState({ tableProps });
    };
}

export default LobasRoofTable;
